import { render, staticRenderFns } from "./InfiniteSelect.vue?vue&type=template&id=49e4c39c&scoped=true"
import script from "./InfiniteSelect.vue?vue&type=script&lang=js"
export * from "./InfiniteSelect.vue?vue&type=script&lang=js"
import style0 from "./InfiniteSelect.vue?vue&type=style&index=0&id=49e4c39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4c39c",
  null
  
)

export default component.exports